import { render, staticRenderFns } from "./DataTableCountryHolidays.vue?vue&type=template&id=2c01cb64&scoped=true"
import script from "./DataTableCountryHolidays.vue?vue&type=script&lang=js"
export * from "./DataTableCountryHolidays.vue?vue&type=script&lang=js"
import style0 from "./DataTableCountryHolidays.vue?vue&type=style&index=0&id=2c01cb64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c01cb64",
  null
  
)

export default component.exports